import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { toast } from 'react-toastify';
import ListShip from '../../../components/ProjectsAndVessels/Projects/list'; // consider renaming this to ListProject
import constant from '../../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_project_visibility, v3_projects } from '../../../actions/v3/projectAndVessel';
import SearchFilter from '../../../components/ProjectsAndVessels/Projects/searchFilter';
import { replacePageState } from '../../../utils';

const List = (props) => {
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');

    useEffect(() => {
        fetchProjects();
    }, [currentPage, limit, payload]);

    const fetchProjects = () => {
        v3_projects(currentPage, limit, payload).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listProject.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error || "Failed to fetch project list");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Something went wrong");
        });
    };

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE;

        v3_project_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    projects: prevState.projects.map(item =>
                        item.ID === record.ID
                            ? { ...item, IS_ACTIVE: newStatus }
                            : item
                    )
                }));

                toast.success(res.result.message);
            } else {
                toast.error("Failed to update project visibility");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating project visibility");
        });
    };

    return (
        <Layout title="Project List">
            <SearchFilter
                onSearch={(newPayload) => { setPayload(newPayload) }}
                onReset={() => { setPayload('') }}
            />
            {data && (
                <ListShip
                    onChangeVisibility={onChangeVisibility}
                    limit={limit}
                    data={data}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </Layout>
    );
};

export default List;
